__turbopack_context__.v({
  "axis": "MatrixLoader-module__U92h4W__axis",
  "edge": "MatrixLoader-module__U92h4W__edge",
  "far": "MatrixLoader-module__U92h4W__far",
  "inner": "MatrixLoader-module__U92h4W__inner",
  "loader": "MatrixLoader-module__U92h4W__loader",
  "od-matrix-axis": "MatrixLoader-module__U92h4W__od-matrix-axis",
  "od-matrix-edge": "MatrixLoader-module__U92h4W__od-matrix-edge",
  "od-matrix-far": "MatrixLoader-module__U92h4W__od-matrix-far",
  "od-matrix-inner": "MatrixLoader-module__U92h4W__od-matrix-inner",
});
